import { useSelector } from 'react-redux'
import { useAmIBlockedByExclusiveUi } from './useAmIBlockedByExclusiveUi'
import { originalVersionFlowFetchErrorSelector } from '../../../features/serverBots/selectors'

export function useIsReadOnlyModeForUserEdit(): boolean {
  const blockedByExclusiveUi = useAmIBlockedByExclusiveUi()
  const originalVersionFetchError = useSelector(originalVersionFlowFetchErrorSelector)

  return blockedByExclusiveUi && !originalVersionFetchError
}
